<div class="table-responsive">
  <table mat-table [dataSource]="properties" class="gen_table">
    <ng-container matColumnDef="select" sticky>
      <th mat-header-cell mat-header-cell *matHeaderCellDef></th>
      <td mat-cell mat-cell *matCellDef="let element; let i = index">
        <mat-radio-button color="primary" [checked]="selectedIndex === i"> </mat-radio-button>
      </td>
    </ng-container>

    <!-- Slno -->
    <ng-container matColumnDef="slNo" sticky>
      <th mat-header-cell *matHeaderCellDef>#</th>
      <td mat-cell *matCellDef="let element; let i = index">
        {{
          paginationInfo
            ? paginationInfo.pageSize * (paginationInfo.pageIndex + 1) - paginationInfo.pageSize + (i + 1)
            : ''
        }}
      </td>
    </ng-container>

    <!-- Address Column -->
    <ng-container matColumnDef="address" sticky>
      <th mat-header-cell *matHeaderCellDef>Address</th>
      <td mat-cell *matCellDef="let element">
        <div>
          <h6 class="mb-1">{{ element.StreetAddress | uppercase }}</h6>
          <span style="font-size: 0.8rem"> {{ element.City | uppercase }}, </span>
          <span style="font-size: 0.8rem"> {{ element.StateOrProvince | uppercase }} </span>
          <span style="font-size: 0.8rem"> {{ element.PostalCode | uppercase }} </span>
        </div>
      </td>
    </ng-container>
    <!-- Image -->
    <ng-container matColumnDef="image">
      <th mat-header-cell *matHeaderCellDef>Image</th>
      <td mat-cell *matCellDef="let element">
        <img
          [ngStyle]="{ 'max-height.px': '57px', overflow: 'hidden', width: '80px', margin: '2px 0px 2px 0px' }"
          [src]="_getImageUrl(element.ImageURLs)"
        />
      </td>
    </ng-container>
    <!-- APN Column -->
    <ng-container matColumnDef="apn">
      <th mat-header-cell *matHeaderCellDef>APN</th>
      <td mat-cell *matCellDef="let element">{{ element.ParcelNumber || element.PublicRecord?.ParcelNumber }}</td>
    </ng-container>

    <!-- Record Source Column -->
    <ng-container matColumnDef="source">
      <th mat-header-cell *matHeaderCellDef>Source</th>
      <td mat-cell *matCellDef="let element">{{ element.Source }}</td>
    </ng-container>

    <!-- MLS Number Column -->
    <ng-container matColumnDef="mlsNo">
      <th mat-header-cell *matHeaderCellDef>MLS Number</th>
      <td mat-cell *matCellDef="let element">{{ element.MLSListingNumber }}</td>
    </ng-container>

    <!-- Property Type Column -->
    <ng-container matColumnDef="propertyType">
      <th mat-header-cell *matHeaderCellDef>Property Type</th>
      <td mat-cell *matCellDef="let element">{{ element.PropertySubType }}</td>
    </ng-container>

    <!-- Beds Column -->
    <ng-container matColumnDef="bed">
      <th mat-header-cell *matHeaderCellDef>Beds</th>
      <td mat-cell *matCellDef="let element">
        {{ element.BedroomsTotal || element.PublicRecord?.BedroomsTotal | number: '1.0-2' }}
      </td>
    </ng-container>

    <!-- Baths Column -->
    <ng-container matColumnDef="bath">
      <th mat-header-cell *matHeaderCellDef>Baths</th>
      <td mat-cell *matCellDef="let element">
        {{ element.BathroomsDecimal || element.PublicRecord?.BathroomsDecimal | number: '1.0-2' }}
      </td>
    </ng-container>

    <!-- GLA Column -->
    <ng-container matColumnDef="gla">
      <th mat-header-cell *matHeaderCellDef>GLA (sq.ft)</th>
      <td mat-cell *matCellDef="let element">
        {{ element.LivingArea || element.PublicRecord?.LivingArea | number: '1.0-0' }}
      </td>
    </ng-container>

    <!-- Lot Size Column -->
    <ng-container matColumnDef="lotSize">
      <th mat-header-cell *matHeaderCellDef>Lot Size (sq.ft)</th>
      <td mat-cell *matCellDef="let element">
        {{ element.LotSizeSquareFeet || element.PublicRecord?.LotSizeSquareFeet | number: '1.0-0' }}
      </td>
    </ng-container>

    <!-- Last Sale Date Column -->
    <ng-container matColumnDef="lastSaleDate">
      <th mat-header-cell *matHeaderCellDef>Last Sale Date</th>
      <td mat-cell *matCellDef="let element">{{ element.CloseDate }}</td>
    </ng-container>

    <!-- Last Sale Price Column -->
    <ng-container matColumnDef="lastSalePrice">
      <th mat-header-cell *matHeaderCellDef>Last Sale Price</th>
      <td mat-cell *matCellDef="let element">
        {{ element.ClosePrice | currency: 'USD' : 'symbol' : '1.0-0' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="ownerName">
      <th mat-header-cell *matHeaderCellDef>Owner</th>
      <td mat-cell *matCellDef="let element">
        {{ element.OwnerName || element.PublicRecord?.OwnerName }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns; let i = index"
      (click)="selectedIndex = i; propertySelected.emit(row)"
      [ngClass]="{ 'make-highLight': i == selectedIndex }"
    ></tr>
  </table>
</div>
<mat-paginator
  #paginator
  [pageSize]="paginationInfo?.pageSize || 0"
  [pageSizeOptions]="paginationInfo?.pageSizeOptions || [10, 25, 50, 100]"
  [showFirstLastButtons]="'true'"
  [pageIndex]="paginationInfo?.pageIndex || 0"
  [length]="count"
  (page)="pageEventHandler($event)"
/>
